import { EmblaCarouselType } from "embla-carousel";
import { ref, Ref, watch } from "vue";

export const usePrevNextButtons = (
  emblaApi: Ref<EmblaCarouselType | undefined>
) => {
  const nextBtnDisabled = ref(true);
  const prevBtnDisabled = ref(true);

  watch(emblaApi, (newEmblaApi) => {
    const togglePrevNextBtnsState = () => {
      prevBtnDisabled.value = !newEmblaApi?.canScrollPrev();
      nextBtnDisabled.value = !newEmblaApi?.canScrollNext();
    };

    newEmblaApi
      ?.on("select", togglePrevNextBtnsState)
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState);
  });

  const handlePrev = () => {
    emblaApi.value?.scrollPrev();
  };

  const handleNext = () => {
    emblaApi.value?.scrollNext();
  };

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    handlePrev,
    handleNext,
  };
};
